export default {

    async abreTicket({dispatch, commit, rootState}, ticket)
    {
        return {}
        let token = rootState.system.token

        let { data, status } = await rootState.system.$barramento.post(`loginServer/usuarios/createticket`, ticket, token)
        //console.log(data)

        if(data) return true
        else return false
    },

    async findTickets({dispatch, commit, rootState})
    {
        return {}
        let token = rootState.system.token
        
        let { data, status } = await rootState.system.$barramento.get(`loginServer/tickets/usuario`, token)

        commit('SET_TICKETS', data.results)
        return data
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/zendesk/actions.js